import React from 'react';
import { Card, CardContent } from './ui/card';
import { ShieldCheck, BookOpen, Building2, LineChart } from 'lucide-react';
import { whyChooseUsData } from '../data/mock';

const iconMap = {
  'shield-check': ShieldCheck,
  'book-open': BookOpen,
  'building-2': Building2,
  'line-chart': LineChart
};

export const WhyChooseUsSection = () => {
  return (
    <section id="why-choose-us" className="py-24 bg-muted/30">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6">
            Why Shine Core Advisory LLC?
          </h2>
          <p className="text-lg text-muted-foreground">
            We deliver more than compliance — we provide structured financial systems that support confident decision-making.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {whyChooseUsData.map((item) => {
            const Icon = iconMap[item.icon];
            return (
              <Card
                key={item.id}
                className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-secondary hover:-translate-y-2 bg-white"
              >
                <CardContent className="p-6 text-center">
                  <div className="mb-4 inline-flex items-center justify-center w-16 h-16 rounded-full bg-secondary/10 text-secondary group-hover:bg-secondary group-hover:text-white transition-all duration-300">
                    <Icon size={32} />
                  </div>
                  <h3 className="text-xl font-bold text-primary mb-3">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-white rounded-2xl shadow-lg p-8 max-w-2xl">
            <p className="text-lg font-semibold text-primary mb-2">
              Ready to experience the Shine Core Advisory LLC difference?
            </p>
            <p className="text-muted-foreground">
              Join 100+ UAE businesses that trust us with their financial compliance and reporting.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
